/**
 * String utility functions for text manipulation
 */

/**
 * Normalize string by removing accents and converting to lowercase
 * Used for accent-insensitive search across the application
 *
 * @param {string} str - String to normalize
 * @returns {string} Normalized string without accents in lowercase
 *
 * @example
 * normalizeString('José García') // returns 'jose garcia'
 * normalizeString('Montserrat') // returns 'montserrat'
 */
export function normalizeString(str) {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
